import React, { useRef } from "react";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import SignatureCanvas from "react-signature-canvas";
import { useTranslation } from "react-i18next";
function UploadSignatureModal({ isOpen, toggle, loadFile }) {
  const { t } = useTranslation();
  const signatureRef = useRef({});
  const [isSigned, setIsSigned] = React.useState(false);
  const [file1, setFile1] = React.useState("");
  const clear = () => {
    signatureRef.current.clear();

    setIsSigned(false);
  };
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    setFile1(new File([u8arr], filename, { type: mime }));
    return new File([u8arr], filename, { type: mime });
  }
  const save = () => {
    toggle();
    const file = dataURLtoFile(
      signatureRef.current.toDataURL("image/png"),
      "Signature"
    );
    loadFile(file);
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalBody>
        <div className="autoriaModal">
          <h3>{t("services.copyright.form.modals.signature.title")}</h3>
          <FontAwesomeIcon
            icon={faTimes}
            className="closeButton"
            size="sm"
            onClick={toggle}
          />
          <div className="modalContent">
            <div className="signaturePad">
              <SignatureCanvas
                ref={signatureRef}
                onBegin={() => setIsSigned(true)}
              />
            </div>
          </div>
          <div className="buttons">
            <button className="first" onClick={clear}>
              {t("services.copyright.form.modals.signature.reset")}
            </button>
            <button
              className="second"
              onClick={save}
              disabled={!isSigned}
              style={!isSigned ? { opacity: 0.7 } : {}}
            >
              {t("services.copyright.form.modals.signature.continue")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default UploadSignatureModal;
